<template>
    <DsAvatarBase
        :config="{
            type: 'bank',
            size,
            logoUrl,
        }"
    />
</template>

<script setup lang="ts">
import type { BankAvatarProps } from './DsAvatarBase.vue';
import DsAvatarBase from './DsAvatarBase.vue';

defineProps<Omit<BankAvatarProps, 'type'>>();
</script>
